import { css } from '@emotion/react';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';
import { PILL_COLOR } from './mentoring-program/program-configuration/program-setup/alias-setting';

const DOT_SIZE = 8;

const getDotStyles = (role: MentoringProgramRole, size: number) => css`
  display: inline-block;
  flex-shrink: 0;
  height: ${size}px;
  width: ${size}px;
  border-radius: 50%;
  background-color: ${PILL_COLOR[role].background};
`;

type ParticipantDotStyles = {
  role: MentoringProgramRole;
  size?: number;
  className?: string;
}

const ParticipantDot = ({
  role,
  size = DOT_SIZE,
  className = '',
}: ParticipantDotStyles) => (
  <span css={getDotStyles(role, size)} className={className}></span>
);

export default ParticipantDot;
